<template>
  <div>
    <div class="row search-row" v-show="!loading">
      <div class="small-1 columns" v-show="drivers.length !== 0">
        <div class="select-all">
          <label class="field-label">Select All:</label>
          <div class="checkbox" @click="selectAll">
            <i class="fas fa-check-square fa-2x" v-if="checked"></i>
            <i class="fas fa-square fa-2x" v-else></i>
          </div>
        </div>
      </div>
      <div class="small-3 columns">
        <label class="field-label">Search:</label>
        <div class="search">
          <div class="search-input-box">
            <input type="text" v-model="searchInput" ref="search" :disabled="loading"
              v-on:keypress.enter="search" v-on:blur="blurSearch">
            <transition name="slide-left">
              <i class="far fa-times-circle fa-lg" @click="clearSearch"
                v-if="searchInput.length > 0"></i>
            </transition>
          </div>
          <button :class="{'button xsmall success':true, 'disabled':loading}" @click="search">
            <i class="fas fa-search fa-lg"></i>
          </button>
        </div>
      </div>
      <div class="small-2 columns">
        <div class="type">
          <label class="field-label">License Type:</label>
          <select v-model="type" :disabled="loading" class="type-select">
            <option value="all">{{ $t('provider.list.filter.all') }}</option>
            <option value="tcp">{{ $t('provider.list.filter.tcp') }}</option>
            <option value="tnc">{{ $t('provider.list.filter.tnc') }}</option>
            <option value="psc">PSC</option>
          </select>
        </div>
      </div>
      <div class="small-2 columns end">
        <div class="status">
          <label class="field-label">Status:</label>
          <select v-model="statusTable" :disabled="loading" class="status-select">
            <option value="unarchived">{{ $t('provider.list.filter.allNonArchive') }}</option>
            <option value="active">{{ $t('provider.list.filter.active') }}</option>
            <option value="inactive">{{ $t('provider.list.filter.inactive') }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="loader" v-show="loading">
      <div>
        <i class="fas fa-spinner fa-spin"></i>
        <span>Getting Drivers</span>
      </div>
    </div>
    <div :class="{'driver-modal':!loading, 'empty':drivers.length === 0 && !loading}">
      <div v-for="driver in drivers" :key="driver.id" :class="{'driver-info':true, 'checked':checkedDriver(driver.id)}" @click="selectDriver(driver.id)">
        <div class="check-box">
          <i class="fas fa-check-square fa-2x" v-if="checkedDriver(driver.id)"></i>
          <i class="fas fa-square fa-2x" v-else></i>
        </div>
        <div class="driver-images">
          <img :src="driver.driverImg" :alt="driver.business + ' pic'" class="driver-img">
          <img :src="driver.carImg" :alt="driver.business + ' car'" class="car-img">
        </div>
        <div class="driver-details">
          <p class="driver-name"><a :href="'/#/provider/' + driver.id" target="_blank">{{driver.business}}</a></p>
          <p>{{driver.car}} | {{driver.plateNo}}</p>
        </div>
      </div>
      <div v-show="drivers.length === 0 && !loading" class="empty-result">
        <i class="far fa-frown-open fa-3x"></i><br/>
        No record found!
      </div>
    </div>


    <div class="fixed-bottom" v-show="!loading">
      <div class="row">
        <div class="small-3 small-offset-4 columns">
          <a class="button cta" @click="closeDriverModal">Cancel</a>
          <a class="button cta success" @click="save">Save</a>
        </div>
        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i" :key="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiProviderList from '@/modules/api/provider/list'
import ApiServices from '@/modules/api/services'

export default {
  name: 'enable-drivers',
  data () {
    return {
      searchInput: '',
      blurDelay: ''
    }
  },
  computed: {
    checked: {
      get: function () { return this.$store.state.services.checked },
      set: function (value) {
        this.$store.commit('services/setCheck', value)
      }
    },
    enabledDrivers () { return this.$store.state.services.enabledDrivers },
    drivers () { return this.$store.state.services.users.list },
    perPage: {
      get: function () { return this.$store.state.services.users.perPage },
      set: function (value) {
        this.$store.commit('services/setUserPerPage', parseInt(value))
        this.$store.commit('services/setUserCurrentPage', 1)
        this.getList()
      }
    },
    pageData () {
      let tableData = this.$store.state.services.users
      let start = (tableData.currentPage * tableData.perPage) - (tableData.perPage - 1)
      let end = tableData.currentPage * tableData.perPage
      return {
        start: start < 1 ? 1 : start,
        end: end > tableData.maxList ? tableData.maxList : end,
        max: tableData.maxList
      }
    },
    loading () { return this.$store.state.services.users.isLoading },
    currentPage: {
      get: function () { return this.$store.state.services.users.currentPage },
      set: function (value) {
        this.$store.commit('services/setUserCurrentPage', parseInt(value))
        this.getList()
      }
    },
    currentOrder () {
      let prov = this.$store.state.services.users
      return { field: prov.order, asc: prov.orderAsc }
    },
    isLastPage () {
      let prov = this.$store.state.services.users
      return (prov.currentPage * prov.perPage) >= prov.maxList
    },
    totalPage () {
      let prov = this.$store.state.services.users
      return Math.ceil(prov.maxList / prov.perPage)
    },
    statusTable: {
      get: function () { return this.$store.state.services.users.status },
      set: function (value) {
        this.$store.commit('services/setUserStatus', value)
        this.refreshTable()
      }
    },
    type: {
      get: function () { return this.$store.state.services.users.type },
      set: function (value) {
        this.$store.commit('services/setUserType', value)
        this.refreshTable()
      }
    }
  },
  methods: {
    checkedDriver (id) {
      if (this.enabledDrivers.length < 0) { return }
        return this.enabledDrivers.filter(x => x===id).length > 0
      },
    search () {
      this.$store.commit('services/setUserSearch', this.searchInput)
      this.refreshTable()
    },
    blurSearch () {
      let self = this
      if (self.$store.state.services.users.search === self.searchInput.trim()) {
        return
      }

      self.blurDelay = setTimeout(function () {
        self.search()
      }, 500)
    },
    getList () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('services/resetUsers')
      self.$store.commit('services/setUserIsLoading', true)
      ApiProviderList.getList(self, {}, res => {
        self.$store.commit('services/setUserIsLoading', false)
        let listedDrivers = self.drivers.map(x => x.id)
        if (listedDrivers.every(x => self.enabledDrivers.includes(x))) {
          self.checked = true
        } else {
          self.checked = false
        }
      })

    },
    selectDriver (id) {
      let self = this
      if(!self.enabledDrivers.includes(id)) {
        self.enabledDrivers.push(id)
      } else {
        self.enabledDrivers.splice(self.enabledDrivers.indexOf(id), 1)
        self.checked = false
      }

      if(self.enabledDrivers.length === 0) {
        self.checked = false
      }
      let drivers = self.drivers.map(x => x.id)
      if (drivers.every(id => self.enabledDrivers.includes(id))) {
        self.checked = true
      }
    },
    closeDriverModal () {
      this.clearSearch()
      this.$emit('clicked')
    },
    prev () {
      if (this.currentPage === 1) { return }
      this.$store.commit('services/setUserCurrentPage', this.$store.state.services.users.currentPage - 1)
      this.getList()
    },
    next () {
      if (this.isLastPage) { return }
      this.$store.commit('services/setUserCurrentPage', this.$store.state.services.users.currentPage + 1)
      this.getList()
    },
    clearSearch () {
      if (this.blurDelay) { clearTimeout(this.blurDelay) }
      if (this.loading) { return }
      this.searchInput = ''
      this.$store.commit('services/setUserSearch', this.searchInput)
      this.refreshTable()
    },
    refreshTable () {
      let self = this
      if (self.loading) { return }

      self.$store.commit('services/setUserIsLoading', true)
      self.$store.commit('services/resetUsers')
      self.$store.commit('services/setUserCurrentPage', 1)

      ApiProviderList.getList(self, {}, res => {
        self.$store.commit('services/setUserIsLoading', false)
        let listedDrivers = self.drivers.map(x => x.id)
        if (listedDrivers.every(x => self.enabledDrivers.includes(x))) {
          self.checked = true
        } else {
          self.checked = false
        }
      })
    },
    selectAll () {
      let self = this
      self.checked = !self.checked
      let checkedDrivers = self.enabledDrivers
      if(self.checked) {
        self.drivers.forEach(x => {
          if(!checkedDrivers.includes(x.id)) {
            checkedDrivers.push(x.id)
          }
        });
      } else {
        self.drivers.forEach(x => {
          checkedDrivers.splice(self.enabledDrivers.indexOf(x.id), 1)
        })
      }
      self.$store.commit('services/setEnabledDrivers', checkedDrivers)
    },
    save () {
      let self = this
      ApiServices.updateEnabledDrivers(self, {}, res => {
        let response = {
          show: true,
          status: 'success',
          message: 'Enabled Success!',
          extra: ''
        }
        if (res.error) {
          response.status = 'error'
          response.message = 'Oops! Something went wrong...'
          response.extra = res.error.message
        }
        self.$emit('enableModal', response)
      })
    }
  },
  mounted () {
    // let self = this
    // self.$store.commit('services/setUserCurrentPage', 1)
  }
}
</script>

<style lang="scss" scoped>
.loader {
  height: 150px;
  text-align: center;

  div {
    position: absolute;
    top:50%;
    left: 0;
    width: 100%;
    transform: translateY(-50%);
    i, span {
      color: #2a2a2a;
      font-size: 21px;
      font-weight: 600;
    }
  }
}
.field-label{
  font-size: 13px;
  color: #999;
  line-height: 1;
  display: block;
  margin-bottom: 4px;
  text-align: left;
}
.status, .type {
  display: inline-block;
  padding-left: 20px;
  width: 100%;
}
.status {
  padding-left: 45px;
}
.status-select, .type-select{
  padding: 10px;
  height: 46px;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: right 50%;
  width: 175px;
  cursor: pointer;

  &[disabled]{ background-color: #ebebe4; }
}
.select-all {
  display: inline-block;
  padding-left: 10px;
  width: 100%;
  .checkbox {
    text-align: left;
    cursor: pointer;
    margin-top: 8px;

    .fa-check-square{ color: #27d979; }
    .fa-square {
      color: #d8e8dd;
      &:hover {
        color: #f4eccb;
      }
      }
  }
}
.empty {
  -webkit-column-count: 1 !important;
  -moz-column-count: 1 !important;
  column-count: 1 !important;
  padding: 35px 0;
  width: 100%;
}
.driver-modal {
  -webkit-column-count: 4;
  -moz-column-count: 4;
  column-count: 4;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding: 15px 0;
  margin: 10px 0;

  .driver-info {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
    border: 1px solid #ddd;
    margin-bottom: 6px;
    width: 100%;
    padding: 9px;
    height: 150px;
    overflow: hidden;

    &:hover {
      background-color: #fff8dc;
      cursor: pointer;
    }

    .check-box {
      float: left;
      width: 30px;

      i {
      margin-right: 5px;
      color: #aaa;
      font-size: 18px;
      }

      .fa-check-square{ color: #2fd77e; }
      .fa-square{ color: #d8e8dd; }
    }

    .driver-img, .car-img {
      height: 75px;
      width: 75px;
      border: 1px solid #ddd;
      border-radius: 50%;
      margin-left: -18px;
      overflow: hidden;
      background-color: #ddd;
    }

    .car-img {
      margin-left: -15px;
    }

    .driver-details {
      text-align: center;

      p {
        margin: 0;
        font-size: 15px;
      }

      .driver-name {
        font-weight: 600;
        margin-top: 8px;
        font-size: 16px;
        a {
          text-decoration: none;
          color: #3c3c3c;
          &:hover {
            color: #0D79F2 !important;
          }
        }
      }
    }
  }
  .checked {
    background-color: #fff8dc;
  }

}
.fixed-bottom {
  bottom: 0;
  text-align: right;
}

.pagination{
    text-align: right;
    padding: 10px 10px;

    span{
      display: inline-block;
      margin-right: 5px;
    }
    select{
      height: 30px;
      vertical-align: middle;
      max-width: 40%;
    }
    .prevNext{
      margin: 0 2px;
      padding: 0 8px;
      border: 1px solid #bbb;
      background: #fff;
      cursor: pointer;
      vertical-align: middle;
      height: 30px;

      i{ line-height:28px; }
      &.disabled{
        opacity: .4;
        cursor: default;
      }
    }
  }

.search-row {
  margin-left: 0 !important;
  margin-right: 0 !important;

  .search {
    box-sizing: border-box;
    display: flex;
    width: 100%;

    .search-input-box{
      width: 100%;
      position: relative;

      input{
        display: inline-block;
        vertical-align: middle;
        margin-top: 0;
        border-radius: 5px 0 0 5px;
        padding-right: 30px;
        &.has-error{ border-color:#f33a27; }
      }
      i{
        position: absolute;
        top: 0;
        right: 5px;
        color: #d92626;
        cursor: pointer;
        line-height: 46px;
      }
    }
    button{
      display: inline-block;
      vertical-align: middle;
      line-height: 1;
      border-radius: 0 5px 5px 0;
      padding: 0 20px;
    }
  }
}

.slide-left-enter-active, .slide-left-leave-active { transition: all .3s ease; }
.slide-left-enter, .slide-left-leave-to {
  transform: translateX(30px);
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Services/EnableDrivers.vue